import FormatBoldIcon from "@mui/icons-material/FormatBold";
import FormatItalicIcon from "@mui/icons-material/FormatItalic";
import FormatStrikethroughIcon from "@mui/icons-material/FormatStrikethrough";
import FormatUnderlinedIcon from "@mui/icons-material/FormatUnderlined";
import { Tooltip } from "@mui/material";

import MenuButton from "../MenuButton";

const TextStyleButtons = ({ editor }) => {
	if (!editor) return null;

	return (
		<>
			<Tooltip title="Bold">
				<MenuButton
					isActive={editor.isActive("bold")}
					onClick={() => editor.chain().focus().toggleBold().run()}
				>
					<FormatBoldIcon fontSize="small" />
				</MenuButton>
			</Tooltip>
			
			<Tooltip title="Italic">
				<MenuButton
					isActive={editor.isActive("italic")}
					onClick={() => editor.chain().focus().toggleItalic().run()}
				>
					<FormatItalicIcon fontSize="small" />
				</MenuButton>
			</Tooltip>
			
			<Tooltip title="Underline">
				<MenuButton
					isActive={editor.isActive("underline")}
					onClick={() => editor.chain().focus().toggleUnderline().run()}
				>
					<FormatUnderlinedIcon fontSize="small" />
				</MenuButton>
			</Tooltip>
			
			<Tooltip title="Strikethrough">
				<MenuButton
					isActive={editor.isActive("strike")}
					onClick={() => editor.chain().focus().toggleStrike().run()}
				>
					<FormatStrikethroughIcon fontSize="small" />
				</MenuButton>
			</Tooltip>
		</>
	);
};

export default TextStyleButtons;